import React, { useEffect } from "react";
import styles from "./IPCameraVideoStreaming.module.css";
import { FaDotCircle } from "react-icons/fa";
import ReactPlayer from "react-player";
import {
  openConfirmationPopup,
  openFailDialog,
} from "../../../../Redux/Actions/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import { setAvsChannelList } from "../../../../Redux/Actions/VideoStreamingActions";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import LoadingButton from "../../../../Common/LoadingButton";
import userService from "../../../../services/user.service";

function IVSPlayer({
  camera,
  setRefArray,
  refArray,
  socket,
  setLoadingButton,
  loadingButton,
}) {
  const schoolId = getFromLocalStorage("schoolId");
  const userId = getFromLocalStorage("currentUserId");
  const adminRole = getFromLocalStorage("loginRole");
  const assignedRight = JSON.parse(getFromLocalStorage("assignedRights") || []);
  const assignedRights = assignedRight.map((item) => item.displayName);
  const { videoStreamAvsChannelList } = useSelector(
    (state) => state?.videoStreamData
  );

  const dispatch = useDispatch();
  useEffect(() => {
    setRefArray((prevRefs) => ({
      ...prevRefs,
      [camera.id]: prevRefs[camera.id] || React.createRef(),
    }));
  }, [camera.id]);

  const stopButtonHandler = async (item) => {
    if (item?.isPrimaryChannel && videoStreamAvsChannelList?.length !== 1) {
      openFailDialog(dispatch, {
        open: true,
        message: "This is parent channel. Please stop other channel first.",
      });
    } else {
      openConfirmationPopup(dispatch, {
        confirmationPopup: {
          open: true,
          message: "Are You Sure, You Want To Delete Channel?",
          btnColor: "red",
          btnText: "Yes",
          type: "Delete IVS channel",
          item: item,
          socket: socket,
          videoStreamAvsChannelList: videoStreamAvsChannelList,
          userId,
          getAllLiveChannel: () => getAllLiveIvsChannel(),
          setLoadingButton: setLoadingButton,
        },
      });
    }
  };

  const getAllLiveIvsChannel = () => {
    if (videoStreamAvsChannelList.length == 1) {
      userService
        .sendLiveStreamingNotification({
          id: userId,
          schoolId,
          associationType: "Stopped Stream",
        })
        .then(() => {})
        .catch((error) => {
          openFailDialog(dispatch, {
            open: true,
            message: "Something Went Wrong",
          });
        });
    }
    setAvsChannelList(dispatch, schoolId);
  };

  return (
    <div className={styles.videoPlayerForStream}>
      <span className="bold fs-16">Camera Angle: {camera.angle}</span>
      {camera.isAssigned ? (
        <span className={styles.liveIcon}>
          <FaDotCircle className="green mg-right-5" />
          Live
        </span>
      ) : (
        <span className={styles.liveIcon}>
          <FaDotCircle className="red mg-right-5" />
          Offline
        </span>
      )}
      <ReactPlayer
        id="livePlayer"
        className={`${styles.streamVideoPlayer}`}
        ref={refArray[camera.id]}
        playing={true}
        url={camera?.playbackUrl}
        controls
      />
      {(assignedRights.includes("Record Video") ||
        adminRole === "SCHOOL ADMIN") && (
        <div
          className="mg-top-10 mg-bottom-10"
          onClick={() => stopButtonHandler(camera)}
        >
          <LoadingButton
            text={"Stop"}
            loading={loadingButton === camera.id}
            disabled={loadingButton === camera.id}
            isZIndex={true}
          />
        </div>
      )}
    </div>
  );
}

export default IVSPlayer;
